import {
  PublishingData,
  PublishingPlatform,
  PublishingStepType,
} from '../models/publishing.model';

const tag = '[Publishing]';

export class FetchPublishingDataRequest {
  static readonly type = `${tag} fetch publishing data request`;
  constructor(public appId: number) {}
}

export class FetchPublishingDataSuccess {
  static readonly type = `${tag} fetch publishing data success`;
  constructor(public publishingData: PublishingData) {}
}

export class FetchPublishingDataError {
  static readonly type = `${tag} fetch publishing data error`;
  constructor(public error: any) {}
}

export class UpdateCompletedStepRequest {
  static readonly type = `${tag} update completed step request`;
  constructor(
    public appId: number,
    public platform: PublishingPlatform,
    public step: PublishingStepType,
  ) {}
}

export class UpdateCompletedStepSuccess {
  static readonly type = `${tag} update completed step success`;
}

export class UpdateCompletedStepError {
  static readonly type = `${tag} update completed step error`;
  constructor(public error: any) {}
}

export class TogglePublishingBannerCollapsed {
  static readonly type = `${tag} Toggle Publishing Banner Collapsed`;
}
